class Config {
}
Config.devAdress = '';
export default Config;
